import React, { useState } from 'react';
import { collection, writeBatch, doc, setDoc, getDoc, getDocs, query, where, Timestamp, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

// ─── DATOS FALSOS ───────────────────────────────────────────────
const FAKE_GROUP_ID = 'demo-pitazo-mundial-2026';

const REAL_ADMIN_UID = 'wMo1uORIf2Q2g2P9qJJb0mQSsk13'; // UID real de Tachu

const FAKE_GROUP = {
  id: FAKE_GROUP_ID,
  name: '🔥 Los Cracks del Mundial',
  adminId: REAL_ADMIN_UID,
  adminName: 'Andrés (Admin)',
  plan: 'starter',
  status: 'active',
  currentMembers: 10,
  createdAt: Timestamp.fromDate(new Date('2026-03-01')),
  pointsConfig: { exact: 3, diff: 2, winner: 1 },
};

const FAKE_MEMBERS = [
  { userId: REAL_ADMIN_UID, name: 'Tachu (Tú)',         totalPoints: 47 },
  { userId: 'u2', name: 'Carlos Rodríguez',   totalPoints: 41 },
  { userId: 'u3', name: 'Valentina Torres',    totalPoints: 38 },
  { userId: 'u4', name: 'Sebastián Gómez',     totalPoints: 35 },
  { userId: 'u5', name: 'Daniela Martínez',    totalPoints: 31 },
  { userId: 'u6', name: 'Felipe Herrera',      totalPoints: 28 },
  { userId: 'u7', name: 'Camila Vargas',       totalPoints: 24 },
  { userId: 'u8', name: 'Andrés López',        totalPoints: 19 },
  { userId: 'u9', name: 'Natalia Jiménez',     totalPoints: 15 },
  { userId: 'u10', name: 'Diego Ramírez',      totalPoints: 11 },
];

// Partidos que ya tienen resultado (los primeros del torneo)
const FINISHED_FIXTURES = [
  { id: 'A1', homeScore: 2, awayScore: 1 }, // México 2-1 Sudáfrica
  { id: 'A2', homeScore: 1, awayScore: 0 }, // Corea 1-0
  { id: 'B1', homeScore: 3, awayScore: 1 }, // Canadá 3-1
  { id: 'D1', homeScore: 2, awayScore: 2 }, // USA 2-2 Paraguay
  { id: 'B2', homeScore: 0, awayScore: 1 }, // Qatar 0-1 Suiza
  { id: 'C1', homeScore: 4, awayScore: 0 }, // Brasil 4-0 Marruecos
  { id: 'C2', homeScore: 1, awayScore: 2 }, // Haití 1-2 Escocia
  { id: 'E1', homeScore: 3, awayScore: 0 }, // Alemania 3-0
  { id: 'F1', homeScore: 2, awayScore: 1 }, // Países Bajos 2-1 Japón
  { id: 'H1', homeScore: 1, awayScore: 1 }, // España 1-1 Cabo Verde
];

// Predicciones variadas para que la tabla se vea realista
function generatePredictions() {
  const preds = [];
  const predScores = [
    // [home, away] variadas para cada usuario — algunas exactas, algunas diff, algunas wrong
    [[2,1],[1,0],[2,1],[1,1],[0,1],[3,0],[2,1],[2,0],[1,1],[0,0]],  // u1 - 47pts
    [[1,1],[1,0],[3,1],[2,2],[0,2],[4,0],[0,2],[2,0],[2,1],[1,0]],  // u2 - 41pts
    [[2,0],[2,1],[2,1],[1,2],[0,1],[3,0],[1,2],[1,0],[2,1],[1,1]],  // u3 - 38pts
    [[3,1],[1,0],[1,0],[2,2],[1,1],[2,0],[1,2],[3,1],[1,0],[0,1]],  // u4 - 35pts
    [[2,1],[0,0],[3,1],[0,0],[0,1],[2,0],[2,1],[1,0],[0,0],[1,1]],  // u5 - 31pts
    [[1,0],[1,1],[2,1],[1,2],[1,1],[3,1],[0,1],[2,1],[1,1],[0,0]],  // u6 - 28pts
    [[0,1],[2,1],[1,0],[2,1],[1,0],[1,0],[1,1],[0,0],[2,1],[1,0]],  // u7 - 24pts
    [[1,1],[0,1],[2,0],[0,1],[2,1],[2,1],[0,2],[1,0],[0,1],[1,1]],  // u8 - 19pts
    [[0,2],[1,2],[0,1],[1,0],[2,0],[1,0],[2,1],[0,1],[1,2],[0,1]],  // u9 - 15pts
    [[1,2],[0,2],[1,2],[0,2],[1,2],[0,1],[1,2],[0,2],[0,2],[1,2]],  // u10 - 11pts
  ];

  FAKE_MEMBERS.forEach((member, mIdx) => {
    FINISHED_FIXTURES.forEach((fixture, fIdx) => {
      const [ph, pa] = predScores[mIdx][fIdx];
      const real = fixture;
      let pts = 0;
      if (ph === real.homeScore && pa === real.awayScore) pts = 3;
      else if ((ph - pa) === (real.homeScore - real.awayScore)) pts = 2;
      else if ((ph > pa) === (real.homeScore > real.awayScore) || (ph < pa) === (real.homeScore < real.awayScore)) pts = 1;

      preds.push({
        id: `pred-${member.userId}-${fixture.id}`,
        userId: member.userId,
        userName: member.name,
        groupId: FAKE_GROUP_ID,
        fixtureId: fixture.id,
        homeScore: ph,
        awayScore: pa,
        points: pts,
        calculated: true,
        createdAt: Timestamp.fromDate(new Date('2026-06-11T10:00:00')),
      });
    });
  });
  return preds;
}

export default function DemoSeedPage() {
  const [status, setStatus] = useState('idle');
  const [log, setLog] = useState([]);

  function addLog(msg) {
    setLog(prev => [...prev, msg]);
  }

  async function runSeed() {
    setStatus('loading');
    setLog([]);
    try {
      const batch = writeBatch(db);

      // 1. Crear grupo
      addLog('📁 Creando grupo demo...');
      const groupRef = doc(db, 'groups', FAKE_GROUP_ID);
      batch.set(groupRef, FAKE_GROUP);

      // 2. Crear miembros
      addLog('👥 Creando 10 participantes...');
      FAKE_MEMBERS.forEach(member => {
        const ref = doc(db, 'groups', FAKE_GROUP_ID, 'members', member.userId);
        batch.set(ref, {
          ...member,
          groupId: FAKE_GROUP_ID,
          joinedAt: Timestamp.fromDate(new Date('2026-03-02')),
        });
      });

      // Agregar groupId al usuario real para que aparezca en MisGrupos
      const userRef = doc(db, 'users', REAL_ADMIN_UID);
      batch.update(userRef, {
        groupIds: [FAKE_GROUP_ID],
      });

      // 3. Marcar partidos como terminados
      addLog('⚽ Marcando partidos con resultados...');
      FINISHED_FIXTURES.forEach(f => {
        const ref = doc(db, 'fixtures', f.id);
        batch.update(ref, {
          homeScore: f.homeScore,
          awayScore: f.awayScore,
          status: 'finished',
          updatedAt: serverTimestamp(),
        });
      });

      await batch.commit();

      // 4. Predicciones (batch separado por límite de 500)
      addLog('🎯 Creando predicciones...');
      const predictions = generatePredictions();
      const batch2 = writeBatch(db);
      predictions.forEach(pred => {
        const ref = doc(db, 'predictions', pred.id);
        batch2.set(ref, pred);
      });
      await batch2.commit();

      addLog(`✅ ¡Listo! ${predictions.length} predicciones creadas`);
      addLog('📸 Ya puedes tomar las capturas de pantalla');
      addLog('⚠️ Recuerda correr el script de limpieza después');
      setStatus('done');
    } catch (e) {
      addLog('❌ Error: ' + e.message);
      setStatus('error');
    }
  }

  const s = {
    page: { minHeight: '100vh', background: '#080810', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Oswald',sans-serif", padding: 20 },
    card: { background: '#14141f', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: '2rem', maxWidth: 420, width: '100%', color: '#F5F5F0' },
  };

  return (
    <div style={s.page}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@700&family=Inter:wght@400&display=swap');`}</style>
      <div style={s.card}>
        <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 12 }}>📸</div>
        <div style={{ fontSize: 18, letterSpacing: 2, textAlign: 'center', marginBottom: 4 }}>DEMO SEED</div>
        <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#6B6B7B', textAlign: 'center', marginBottom: 20 }}>
          Crea datos falsos para capturas de Play Store.<br />
          <strong style={{ color: '#E63946' }}>Solo usar para screenshots. Borrar después.</strong>
        </div>

        {log.length > 0 && (
          <div style={{ background: 'rgba(0,0,0,0.3)', borderRadius: 10, padding: '12px 14px', marginBottom: 16, maxHeight: 180, overflowY: 'auto' }}>
            {log.map((l, i) => (
              <div key={i} style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#aaa', marginBottom: 4 }}>{l}</div>
            ))}
          </div>
        )}

        <button disabled={status === 'loading' || status === 'done'} onClick={runSeed}
          style={{ width: '100%', padding: 14, background: status === 'done' ? '#333' : 'linear-gradient(90deg,#F0B429,#C9820A)', border: 'none', borderRadius: 10, fontFamily: "'Oswald',sans-serif", fontSize: 14, fontWeight: 700, color: '#080810', cursor: status === 'done' ? 'default' : 'pointer', letterSpacing: 2 }}>
          {status === 'loading' ? 'CREANDO...' : status === 'done' ? 'DATOS CREADOS ✓' : 'CREAR DATOS DEMO'}
        </button>

        {status === 'done' && (
          <div style={{ marginTop: 14, fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#06B86A', textAlign: 'center' }}>
            Abre la app en <strong>/dashboard/demo-pitazo-mundial-2026</strong> para ver los datos
          </div>
        )}
      </div>
    </div>
  );
}